import React, { useEffect } from 'react';
import './styles.scss';

interface Props {
	className?: string;
}

const TabAnimationWrapper: React.FC<Props> = (props) => {
	useEffect(() => {
		document.getElementById('tabAnimationWrapper')?.addEventListener('animationend', () => {
			document.getElementById('tabAnimationWrapper')?.classList.remove('slideFromTop');
		});

		document.getElementById('tabAnimationWrapper')?.addEventListener('animationcancel', () => {
			document.getElementById('tabAnimationWrapper')?.classList.remove('slideFromTop');
		});
	}, []);

	return (
		<div className={`tabAnimation slideFromTop ${props.className ? props.className : ''}`}>
			<div id="tabAnimationWrapper" className="tabAnimation__wrapper">
				{props.children}
			</div>
		</div>
	);
};

export default TabAnimationWrapper;
